<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col col-md-6 text-center">
        <div
          v-if="alert.type === 'sign-in'"
          class="alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            @click.native="$store.commit('ALERT', {})"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <strong>{{ alert.title }}:</strong>
          {{ alert.message }}
        </div>

        <div class="boxy">
          <h1>
            <i class="fa fa-user-circle" aria-hidden="true"></i>
          </h1>
          <h2>Sign In</h2>
          <p>Choose your Sign In provider.</p>
          <p>
            <button class="btn btn-social btn-facebook" @click="signIn('facebook')">
              <i class="fa fa-facebook"></i> Sign In with Facebook
            </button>
            <br>
            <button class="btn btn-social btn-google" @click="signIn('google')">
              <i class="fa fa-google"></i> Sign In with Google
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "sign-in",
  watch: {
    // call again the method if the route changes
    $route: "setRedirect"
  },
  created() {
    if (this.sessionExpired) this.signOut();
    this.setRedirect();
  },
  mounted() {
    this.$Progress.finish();
  },
  computed: {
    ...mapGetters({
      sessionExpired: "sessionExpired"
    }),
    ...mapState({
      alert: state => state.alert
    })
  },
  methods: {
    ...mapActions({
      signOut: "signOut"
    }),
    signIn(provider) {
      window.location.href = `${process.env.VUE_APP_SSO_URL}/${
        process.env.VUE_APP_SSO_CID
      }/${provider}`;
    },
    setRedirect() {
      if (this.$route.query.redirectUrl) {
        let payload = {
          redirectUrl: this.$route.query.redirectUrl
        };
        this.$store.commit("REDIRECT_SET", payload);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    // document.body.style.backgroundColor = "#eeeeee";
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("ALERT", {}); // clear the alert before we leave
    // document.body.style.backgroundColor = "#ffffff";
    next();
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/_global";

h1 {
  font-size: 6em;
}
.boxy {
  padding: 2em;
}
.btn {
  cursor: pointer;
}
.btn-social {
  position: relative;
  padding-left: 44px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 225px;
  margin-bottom: 0.5em;
}
.btn-social > :first-child {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 32px;
  line-height: 1.5em;
  font-size: 1.6em;
  text-align: center;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
}

.btn-facebook {
  color: #fff;
  background-color: #3b5998;
  &:hover {
    background-color: #2d4373;
  }
}

.btn-google {
  color: #fff;
  background-color: #dd4b39;
  &:hover {
    background-color: #c23321;
  }
}

.btn-twitter {
  color: #fff;
  background-color: #55acee;
  &:hover {
    background-color: #2795e9;
  }
}
</style>
